import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export function updateHeightProfileAction (value) {
  return updateProfileAction({
    type: PROFILES_ACTION.UPDATE_HEIGHT,
    payload: {
      key: PROFILE_KEY.HEIGHT,
      value
    }
  })
}
